// A2UI v0.9 Common Types — DynamicValue, DataBinding, FunctionCall, Action, ChildList

export type DataBinding = {
	path: string;
};

export type FunctionCall = {
	args: Record<string, DynamicValue>;
	call: string;
};

export type DynamicString = string | DataBinding | FunctionCall;
export type DynamicNumber = number | DataBinding | FunctionCall;
export type DynamicBoolean = boolean | DataBinding | FunctionCall;
export type DynamicStringList = string[] | DataBinding | FunctionCall;
export type DynamicValue = string | number | boolean | string[] | DataBinding | FunctionCall;

export type CheckRule = {
	condition: DynamicBoolean;
	message: string;
};

export type ActionEvent = {
	context?: Record<string, DynamicValue>;
	event: string;
};

export type ActionFunctionCall = {
	functionCall: FunctionCall;
};

export type Action = ActionEvent | ActionFunctionCall;

export type ChildReference = string;

export type ChildTemplate = {
	componentId: string;
	path: string;
};

export type ChildList = ChildReference[] | ChildTemplate;

export type Accessibility = {
	description?: string;
	label?: string;
};

export const isDataBinding = (value: unknown): value is DataBinding =>
	typeof value === 'object' &&
	value !== null &&
	'path' in value &&
	typeof (value as DataBinding).path === 'string' &&
	!('call' in value);

export const isFunctionCall = (value: unknown): value is FunctionCall =>
	typeof value === 'object' &&
	value !== null &&
	'call' in value &&
	typeof (value as FunctionCall).call === 'string';

export const isChildTemplate = (value: unknown): value is ChildTemplate =>
	typeof value === 'object' && value !== null && 'componentId' in value && 'path' in value;
